export interface EventData<T = any> {
  readonly type: EVENT_TYPE;
  readonly requestId: string;
  readonly timestamp: string;
  readonly content: T;
}

export type EventCallback<T = any> = (data: EventData<T>) => void;
export interface InitializeOptions {
  readonly token: string;
  readonly humanInTheLoopApiURL: string;
  readonly serviceDiscoveryURL: string;
  readonly emBusURL: string;
  readonly isDebug?: boolean;
  /** WebSocket client can output a lot more logs if needed */
  readonly isWSDebug?: boolean;
}

export const WORKER_LOCKS = {
  MAIN_LOCK: 'HITL-Main-Lock',
  TAB_LOCK_PREFIX: 'HITL-Tab-Lock-',
};

export enum TAB_ROLE {
  MAIN = 'MAIN_TAB',
}

export enum EVENT_TYPE {
  INITIALIZE = 'INITIALIZE',
  INITIALIZE_STATUS_PINGS = 'INITIALIZE_STATUS_PINGS',
  RESPONSE = 'RESPONSE',
  TAB_REGISTER = 'TAB_REGISTER',
  TAB_REGISTER_OK = 'TAB_REGISTER_OK',
  TAB_DISCONNECT = 'TAB_DISCONNECT',
  TAB_SET_FOCUS = 'TAB_SET_FOCUS',
  TAB_SET_MAIN = 'TAB_SET_MAIN',
  TAB_ROLE_CHANGE = 'TAB_ROLE_CHANGE',
  TAB_SET_ACTIVE_CHATS = 'TAB_SET_ACTIVE_CHATS',
  TAB_ASSIGNMENTS_CHANGE = 'TAB_ASSIGNMENTS_CHANGE',
  TOKEN_CHANGE = 'TOKEN_CHANGE',
  PING_STATUS = 'PING_STATUS',
  WS_CONNECTION_ID = 'WS_CONNECTION_ID',
  WS_APP_ACTION = 'WS_APP_ACTION',
  WS_CONNECT = 'WS_CONNECT',
  WS_PING = 'WS_PING',
  WS_CLOSE = 'WS_CLOSE',
  WS_ERROR = 'WS_ERROR',
  WS_SEND_MESSAGE = 'WS_SEND_MESSAGE',
}
